import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import classNames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import { Col } from 'bootstrap';

import { RowTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';

import CuesheetHelper from 'flux/helpers/cuesheetHelper';

import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin.js';
import CuesheetTableListHeaderRow from 'main/components/show/cuesheet.responsive/cueTableListHeaderRow.jsx';
import CueTableListItem from 'main/components/show/cuesheet.responsive/cueTableListItem.jsx';
import AddItemButton from 'main/components/show/cuesheet/addItemButton.jsx';
import Spinner from 'shared/components/misc/simpleSpinner.jsx';

import keyIn from 'shared/lib/immutable/keyIn';

/**
 * Responsive cue list component
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connectFilter(UserSessionStore, 'userId', (state) =>
      state.get('_id'),
    ),
    Reflux.connectFilter(CuesheetResponsiveStore, 'showDetail', (st) =>
      st.get('showDetail'),
    ),
    Reflux.connectFilter(EventViewStore, 'event', (st) =>
      st.filter(keyIn('twentyFourHourClock')),
    ),
    Reflux.connect(CuesheetStore, 'cuesheet'),
    PureRenderMixin,
    CuesheetMixin,
  ],

  render() {
    let rows = this._getCueStateField('rows');

    if (!rows || this._getCueStateField('loading')) {
      return <Spinner />;
    }

    return (
      <Col
        ref={'cuesheetTable'}
        xs={24}
        sm={24}
        md={24}
        lg={24}
        className={classNames('csr-cue-list', 'csr-table')}
        onScroll={this._handleScroll}
      >
        {this._getHeaderNode()}
        {this._getListNode()}
      </Col>
    );
  },

  _handleScroll() {
    let leftOffset = ReactDOM.findDOMNode(this.refs.cuesheetTable).scrollLeft;

    CuesheetResponsiveActions.scrollTableViewHorizontally(leftOffset * -1);
  },

  _getHeaderNode() {
    return <CuesheetTableListHeaderRow />;
  },

  _getListNode() {
    let event = (event = this.state.event);

    return (
      <CueListInner
        twentyFourHourClock={event.get('twentyFourHourClock')}
        userId={this.state.userId}
        cueState={this._getCueState()}
      />
    );
  },
});

/**
 * The inner cuesheet list
 */
let CueListInner = React.createClass({
  mixins: [CuesheetMixin, PureRenderMixin],

  render() {
    let { cueState, userId } = this.props;

    let rows = cueState.get('rows'),
      rowMap = cueState.get('rowMap'),
      settings = cueState.get('settings'),
      userSettings = cueState.get('userSettings'),
      columns = cueState.get('columns'),
      show = cueState.get('show'),
      displayStartTime = show.get('displayStartTime'),
      displayPresetDuration = show.get('displayPresetDuration'),
      displayDuration = show.get('displayDuration'),
      durationDisplayType = show.get('durationDisplayType'),
      presetDurationDisplayType = show.get('presetDurationDisplayType'),
      displayDescription = show.get('displayItemDescriptions'),
      twentyFourHourClock = this.props.twentyFourHourClock;

    let cuesheetWidth = CuesheetHelper.getCuesheetWidth(
      settings,
      userSettings,
      columns,
    );

    let listNodes = rows.map((rowSpec, rowIndex) => {
      let item = rowMap.getIn(rowSpec.get('path')),
        rowType = rowSpec.get('type'),
        rowId = rowSpec.get('path')[2];

      return (
        <CueTableListItem
          key={'cue-list-item-' + item.get('_id')}
          rowIndex={rowIndex}
          rowId={rowId}
          userId={userId}
          isCopied={rowSpec.get('copied')}
          isTracked={rowSpec.get('tracked')}
          trackedUsers={rowSpec.get('trackedUsers')}
          isTitle={rowType === RowTypes.TitleItem}
          hideNotes={cueState.getIn(['userSettings', 'noteColumn', 'hidden'])}
          displayStartTime={displayStartTime}
          displayPresetDuration={displayPresetDuration}
          displayDuration={displayDuration}
          durationDisplayType={durationDisplayType}
          presetDurationDisplayType={presetDurationDisplayType}
          displayDescription={displayDescription}
          twentyFourHourClock={twentyFourHourClock}
          item={item}
          itemNumberAdjusted={this.getItemNumberAdjusted(
            item,
            rowIndex,
            cueState,
          )}
          settings={settings}
          userSettings={userSettings}
          columns={columns}
          cuesheetWidth={cuesheetWidth}
        />
      );
    });

    listNodes = listNodes.push(
      <div className="csr-table-rows-add-btn-container">
        <AddItemButton />
      </div>,
    );

    return <div className="csr-table-rows">{listNodes}</div>;
  },
});
